import { getLinkToMobileApp, LINK_TYPES } from "@/services/DeepLinkService";
import { isNativePlatform } from "@/utils/platform.helpers";

export const getCheckoutStripeRedirect = async (
  platformId: string,
  orderId: string,
  transactionId: string,
  baseUrl = "/cart/checkout/success"
) => {
  const internal = `${baseUrl}?shopDisplayOrderId=${orderId}&orderTransactionId=${transactionId}`;
  const linkToMobileApp = await getLinkToMobileApp(
    LINK_TYPES.CHECKOUT,
    internal,
    platformId
  );

  return {
    internal,
    external:
      isNativePlatform() && linkToMobileApp
        ? linkToMobileApp.toString()
        : new URL(internal, location.href).href,
  };
};
